import { ConfigItem } from 'Core/interfaces'

export enum UsTaxBasicFields {
	id = 'id',
	city = 'city',
	county = 'county',
	taxRate = 'taxRate',
	zipCode = 'zipCode',
	plus4Low = 'plus4Low',
	plus4High = 'plus4High',
	effStartDate = 'effStartDate',
	stateProvince = 'stateProvince'
}

export enum UsTaxSearchField {
	searchResultByState = 'searchResultByState',
	searchResultByCounty = 'searchResultByCounty',
	searchResultByZipCode = 'searchResultByZipCode'
}

export declare namespace UsTax {
	interface Basic {
		[UsTaxBasicFields.id]: number
		[UsTaxBasicFields.city]: BasicString
		[UsTaxBasicFields.taxRate]: number | null
		[UsTaxBasicFields.zipCode]: BasicString
		[UsTaxBasicFields.county]: BasicString
		[UsTaxBasicFields.plus4Low]: BasicString
		[UsTaxBasicFields.plus4High]: BasicString
		[UsTaxBasicFields.effStartDate]: BasicString
		[UsTaxBasicFields.stateProvince]: Entity[]
	}

	namespace Search {
		interface Config {
			[UsTaxSearchField.searchResultByState]: ConfigItem<UsTaxSearchField>
			[UsTaxSearchField.searchResultByCounty]: ConfigItem<UsTaxSearchField>
			[UsTaxSearchField.searchResultByZipCode]: ConfigItem<UsTaxSearchField>
		}

		interface Result {
			[UsTaxSearchField.searchResultByState]: Entity[] | null
			[UsTaxSearchField.searchResultByCounty]: Entity[] | null
			[UsTaxSearchField.searchResultByZipCode]: Entity[] | null
		}
	}
}
